var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
const loggingLevels = ['debug', 'info', 'warning', 'error', 'fatal'];
let Logger = class Logger {
    /**
     * Приватный метод
     * Определяет будет ли сообщение об ошибке залогировано
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции содержат данные, которые необходимо залогировать, а так же level, определяющий будет ли произведено логирование
     */
    logEvent(message, options) {
        const getCurrentLevelLog = () => {
            if (loggingLevels.indexOf(window.REACT_APP_VKHRTEK_LOG_LEVEL) !== -1) {
                return window.REACT_APP_VKHRTEK_LOG_LEVEL;
            }
            return process.env.NODE_ENV === 'production' ? 'info' : 'debug';
        };
        if (loggingLevels.indexOf(getCurrentLevelLog()) <=
            loggingLevels.indexOf(options.level)) {
            this.log(message, options);
        }
    }
    /**
     * Логирует сообщение об ошибке типа "debug"
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции, определяют что будет залогировано
     *  */
    debug(message, options = {}) {
        this.logEvent(message, Object.assign({ level: 'debug' }, options));
    }
    /**
     * Логирует сообщение об ошибке типа "info"
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции, определяют что будет залогировано
     */
    info(message, options = {}) {
        this.logEvent(message, Object.assign({ level: 'info' }, options));
    }
    /**
     * Логирует сообщение об ошибке типа "warning"
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции, определяют что будет залогировано
     */
    warning(message, options = {}) {
        this.logEvent(message, Object.assign({ level: 'warning' }, options));
    }
    /**
     * Логирует сообщение об ошибке типа "error"
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции, определяют что будет залогировано
     */
    error(message, options = {}) {
        this.logEvent(message, Object.assign({ level: 'error' }, options));
    }
    /**
     *  Логирует сообщение об ошибке типа "fatal"
     *
     * @param message - Сообщение об ошибке
     * @param options - Опции, определяют что будет залогировано
     */
    fatal(message, options = {}) {
        this.logEvent(message, Object.assign({ level: 'fatal' }, options));
    }
};
Logger = __decorate([
    injectable()
], Logger);
export { Logger };
